module.exports = __webpack_public_path__ + "img/user-circle-solid.2c968a9b.svg";